import AddUserForm from 'components/addUserForm/AddUserForm';
import '../../styles/fonts/fonts.css';

const AddSubSuperPage = () => {

  return (
    <AddUserForm
      roleName="Sub Super Admin"
      returnEndpoint={'sub-super-admin'}
    />
  )
};

export default AddSubSuperPage;